"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var describe_exports = {};
__export(describe_exports, {
  describeSchema: () => describeSchema
});
module.exports = __toCommonJS(describe_exports);
var import_util = require("@cartographerio/util");
function describeSchema(schema) {
  switch (schema.type) {
    case "Boolean":
      return "Boolean";
    case "Integer":
      return "Integer";
    case "Number":
      return "Number";
    case "String":
      return "String";
    case "Uuid":
      return "Uuid";
    case "Timestamp":
      return "Timestamp";
    case "Geometry":
      return schema.geometryType == null ? "Geometry" : `Geometry(${schema.geometryType})`;
    case "Unknown":
      return "Unknown";
    case "Enum":
      return `Enum(${schema.values.join(",")})`;
    case "Nullable":
      return `Nullable(${describeSchema(schema.param)})`;
    case "Array":
      return `Array(${describeSchema(schema.param)})`;
    case "Tuple":
      return `Tuple(${schema.items.map(describeSchema).join(",")})`;
    case "Dict":
      return `Dict(${describeSchema(schema.key)},${describeSchema(schema.value)})`;
    case "Product":
      return `Product(${Object.entries(schema.fields).map(([name, schema2]) => `${name}=${describeSchema(schema2)}`).join(",")})`;
    case "Sum":
      return `Sum(${Object.entries(schema.products).map(([name, schema2]) => `${name}=${describeSchema(schema2)}`).join(",")})`;
    default:
      return (0, import_util.checkExhausted)(schema);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  describeSchema
});
//# sourceMappingURL=describe.js.map
